import  React from 'react';
import Dashboardimg from '../../Assets/images/Dashboard.svg'
import Buys from '../../Assets/images/invest.svg'
import Saves from '../../Assets/images/saving1.svg'
import Logoutt from '../../Assets/images/logout.png'
import User from '../../Assets/images/user1.svg'
import People from '../../Assets/images/people.png'
import Assest from '../../Assets/images/assestt.svg'
import Transaction from '../../Assets/images/transac.svg'
import SettingsIcon from '@mui/icons-material/Settings';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';

const superAdmin = [
    {
        name: 'Dashboard',
        icon: (
            <img src={Dashboardimg} className=' inline-block' alt='Dashboard'/>
        ),
        link: '/dashboard',
        id: 'dashbord',
    },
    {
      name: 'Users',
      icon: (
        <img src={User} className=' inline-block' alt='People'/>
      ),
      link: '/customers',
      id: 'customers',
  },

    {
        name: 'Wallet',
        icon: (
            <AccountBalanceWalletOutlinedIcon className=' text-gray-500'/>
        ),
        link: '/wallet',
        id: 'wallet',
    },
    {
        name: 'Invest',
        icon: (
          <img src={Buys} className=' inline-block'  alt='buy'/>
        ),
        link: '/investment',
        id: 'invest',
    },

    {
        name: 'Savings',
        icon: (
          <img src={Saves} className=' inline-block' alt='Save'/>
        ),
        link: '/savings',
        id: 'save',
    },
   
    {
        name: 'Asset financing',
        icon: (
          <img src={Assest} className=' inline-block' alt='Listings'/>
        ),
        link: '/assests',
        id: 'asset',
    },
    {
      name: 'Transaction',
      icon: (
        <img src={Transaction} className=' inline-block' alt='Listings'/>
      ),
      link: '/transaction',
      id: 'tran',
  },
    
    {
      name: 'Administrators',
      icon: (
        <img src={User} className=' inline-block' alt='users'/>
      ),
      link: '/users',
      id: 'users',
  },
  {
    name: 'Notification',
    icon: (
      <NotificationsIcon className=' text-gray-500'/>
    ),
    link: '/notification',
    id: 'noti',
},
{
  name: 'Settings',
  icon: (
    <SettingsIcon/>
  ),
  link: '/settings',
  id: 'settings',
},
{
  name: 'Logout',
  icon: (
    <img src={Logoutt} className=' inline-block' alt='logut'/>
  ),
  link: '/logout',
  id: 'logout',
},
  ];

  const operationManager = [
    {
        name: 'Dashboard',
        icon: (
            <img src={Dashboardimg} className=' inline-block' alt='Dashboard'/>
        ),
        link: '/dashboard',
        id: 'dashbord',
    },
    {
        name: 'Wallet',
        icon: (
            <AccountBalanceWalletOutlinedIcon className=' text-gray-500'/>
        ),
        link: '/wallet',
        id: 'wallet',
    },
    {
        name: 'Investment',
        icon: (
          <img src={Buys} className=' inline-block'  alt='buy'/>
        ),
        link: '/investment',
        id: 'invest',
    },
   

   
    {
        name: 'Savings',
        icon: (
          <img src={Saves} className=' inline-block' alt='Save'/>
        ),
        link: '/savings',
        id: 'save',
    },
    {
        name: 'Asset financing',
        icon: (
          <img src={Assest} className=' inline-block' alt='Listings'/>
        ),
        link: '/assests',
        id: 'asset',
    },
    {
      name: 'Transaction',
      icon: (
        <img src={Transaction} className=' inline-block' alt='Listings'/>
      ),
      link: '/transaction',
      id: 'tran',
  },
   
    // {
    //     name: 'Properties',
    //     icon: (
    //       <img src={Listings} className=' inline-block' alt='Listings'/>
    //     ),
    //     link: '/properties',
    //     id: 'properties',
    // },
    {
      name: 'Customers',
      icon: (
        <img src={People} className=' inline-block' alt='People'/>
      ),
      link: '/customers',
      id: 'customers',
  },
    {
      name: 'User',
      icon: (
        <img src={User} className=' inline-block' alt='users'/>
      ),
      link: '/users',
      id: 'users',
  },
  {
    name: 'Notification',
    icon: (
      <NotificationsIcon className=' text-gray-500'/>
    ),
    link: '/notification',
    id: 'noti',
},
{
  name: 'Settings',
  icon: (
    <SettingsIcon/>
  ),
  link: '/settings',
  id: 'settings',
},
{
  name: 'Logout',
  icon: (
    <img src={Logoutt} className=' inline-block' alt='logut'/>
  ),
  link: '/logout',
  id: 'logout',
},
  ];
  const projectManager =[
    {
        name: 'Dashboard',
        icon: (
            <img src={Dashboardimg} className=' inline-block' alt='Dashboard'/>
        ),
        link: '/dashboard',
        id: 'dashbord',
    },
    {
        name: 'Investment',
        icon: (
          <img src={Buys} className=' inline-block'  alt='buy'/>
        ),
        link: '/investment',
        id: 'invest',
    },
   
  //   {
  //     name: 'Projects',
  //     icon: (
  //       <img src={Listings} className=' inline-block' alt='Listings'/>
  //     ),
  //     link: '/projects',
  //     id: 'project',
  // },
   
   
    // {
    //     name: 'Properties',
    //     icon: (
    //       <img src={Listings} className=' inline-block' alt='Listings'/>
    //     ),
    //     link: '/properties',
    //     id: 'properties',
    // },
    {
      name: 'Customers',
      icon: (
        <img src={People} className=' inline-block' alt='People'/>
      ),
      link: '/customers',
      id: 'customers',
  },
  {
      name: 'Asset financing',
      icon: (
        <img src={Assest} className=' inline-block' alt='Listings'/>
      ),
      link: '/assests',
      id: 'asset',
  },
  
{
  name: 'Settings',
  icon: (
    <SettingsIcon/>
  ),
  link: '/settings',
  id: 'settings',
},
{
  name: 'Logout',
  icon: (
    <img src={Logoutt} className=' inline-block' alt='logut'/>
  ),
  link: '/logout',
  id: 'logout',
},
  ];
  const financeManager = [
    {
        name: 'Dashboard',
        icon: (
            <img src={Dashboardimg} className=' inline-block' alt='Dashboard'/>
        ),
        link: '/dashboard',
        id: 'dashbord',
    },
    {
        name: 'Investment',
        icon: (
          <img src={Buys} className=' inline-block'  alt='buy'/>
        ),
        link: '/investment',
        id: 'invest',
    },
  //   {
  //     name: 'Liquidate',
  //     icon: (
  //       <AssessmentIcon className=' text-gray-500'/>
  //     ),
  //     link: '/liquidate',
  //     id: 'liqui',
  // },
//   {
//     name: 'Withdrawal',
//     icon: (
//       <AccountBalanceIcon className=' text-gray-500'/>
//     ),
//     link: '/withdrawal',
//     id: 'withdrawal',
// },
{
        name: 'Savings',
        icon: (
          <img src={Saves} className=' inline-block' alt='Save'/>
        ),
        link: '/savings',
        id: 'save',
    },
{
  name: 'Asset financing',
  icon: (
    <img src={Assest} className=' inline-block' alt='Listings'/>
  ),
  link: '/assests',
  id: 'asset',
},
{
  name: 'Settings',
  icon: (
    <SettingsIcon/>
  ),
  link: '/settings',
  id: 'settings',
},
{
  name: 'Logout',
  icon: (
    <img src={Logoutt} className=' inline-block' alt='logut'/>
  ),
  link: '/logout',
  id: 'logout',
},
  ];

  const operator = [
    {
        name: 'Dashboard',
        icon: (
            <img src={Dashboardimg} className=' inline-block' alt='Dashboard'/>
        ),
        link: '/dashboard',
        id: 'dashbord',
    },
    {
        name: 'Asset financing',
        icon: (
          <img src={Assest} className=' inline-block' alt='Listings'/>
        ),
        link: '/assests',
        id: 'asset',
    },
    
   
  //   {
  //     name: 'Projects',
  //     icon: (
  //       <img src={Listings} className=' inline-block' alt='Listings'/>
  //     ),
  //     link: '/projects',
  //     id: 'project',
  // },
   
   
    // {
    //     name: 'Properties',
    //     icon: (
    //       <img src={Listings} className=' inline-block' alt='Listings'/>
    //     ),
    //     link: '/properties',
    //     id: 'properties',
    // },
  
{
  name: 'Settings',
  icon: (
    <SettingsIcon/>
  ),
  link: '/settings',
  id: 'settings',
},
{
  name: 'Logout',
  icon: (
    <img src={Logoutt} className=' inline-block' alt='logut'/>
  ),
  link: '/logout',
  id: 'logout',
},
  ];



const userRole = localStorage.getItem("userRole");

export default userRole === 'SUPER_ADMIN' || userRole === 'ADMIN' ? superAdmin : userRole === 'OPERATION_MANAGER' ?  operationManager : userRole === 'PROJECT_MANAGER' ?  projectManager : userRole === 'FINANCE_MANAGER' ?  financeManager : userRole === 'OPERATOR' ?  operator : operator
